import { render, staticRenderFns } from "./poundDetail.vue?vue&type=template&id=99f5fa2a"
import script from "./poundDetail.vue?vue&type=script&lang=js"
export * from "./poundDetail.vue?vue&type=script&lang=js"
import style0 from "./poundDetail.vue?vue&type=style&index=0&id=99f5fa2a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports